import { RxJsonSchema } from 'rxdb';

/**
 * Статусы синхронизации документа
 */
export type SyncStatus = 'synced' | 'pending' | 'error';

/**
 * Интерфейс для документа в RxDB
 */
export interface DocumentSchemaType {
  id: string;
  content: any;
  localTimestamp: number;
  serverTimestamp: number;
  lastAccessed: number;
  syncStatus: SyncStatus;
}

/**
 * Схема для коллекции документов в RxDB
 */
export const documentSchema: RxJsonSchema<DocumentSchemaType> = {
  title: 'document schema',
  version: 0,
  description: 'documents with autosave',
  type: 'object',
  primaryKey: 'id',
  properties: {
    id: {
      type: 'string',
      maxLength: 100
    },
    content: {
      type: 'object'
    },
    localTimestamp: {
      type: 'number',
      minimum: 0
    },
    serverTimestamp: {
      type: 'number',
      minimum: 0
    },
    lastAccessed: {
      type: 'number',
      minimum: 0
    },
    syncStatus: {
      type: 'string',
      enum: ['synced', 'pending', 'error']
    }
  },
  required: ['id', 'content', 'localTimestamp', 'serverTimestamp', 'lastAccessed', 'syncStatus'],
  indexes: ['lastAccessed']
}; 